import {z as zod} from "zod";

export type StableLinksWorkspaceCapabilityConfiguration = Record<string, never>;

export const stableLinksWorkspaceCapabilityConfigurationValidator: zod.ZodType<StableLinksWorkspaceCapabilityConfiguration> = zod.strictObject({});
